import { render, staticRenderFns } from "./PoolCardList.vue?vue&type=template&id=22b8a98a&scoped=true&"
import script from "./PoolCardList.vue?vue&type=script&lang=js&"
export * from "./PoolCardList.vue?vue&type=script&lang=js&"
import style0 from "./PoolCardList.vue?vue&type=style&index=0&id=22b8a98a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8a98a",
  null
  
)

export default component.exports